import LottieInner, { LottieProps } from "react-lottie";
import Confetti from "../../assets/lottie/brandclub_success_confetti_v2.json";
import PetArmorConfetti from "../../assets/lottie/confetti_petarmor.json";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

// @ts-ignore
const Lottie = LottieInner.default
  ? // @ts-ignore
    LottieInner.default
  : LottieInner;

const option = {
  loop: true,
  autoplay: true,
  animationData: Confetti,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

interface IConfettiBrandAnimation {
  [brandId: number]: LottieProps["options"];
}

const ConfettiBrandAnimation: IConfettiBrandAnimation = {
  // PetArmor
  173173: {
    ...option,
    animationData: PetArmorConfetti,
  },
};

const getConfettiOptions = (brandId: number | undefined) => {
  if (!brandId) {
    return option;
  }
  return ConfettiBrandAnimation[brandId] || option;
};

export const ConfettiContainer = styled(Box, {
  label: "ConfettiContainer",
})({
  width: "98vw",
  maxWidth: 1000,
  height: "100%",
  overflowX: "visible",
  overflowY: "hidden",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  pointerEvents: "none",
  marginBottom: "25px",
  zIndex: 2,
});

export type StoreConfettiProps = Omit<LottieProps, "options"> & {
  brandId?: number;
};

const StoreConfetti = ({ brandId, ...props }: StoreConfettiProps) => {
  return (
    <Lottie
      isClickToPauseDisabled
      {...props}
      options={getConfettiOptions(brandId)}
    ></Lottie>
  );
};

export default StoreConfetti;
